<div class="bo-auth-phone-input">
  <label class="bo-auth-phone-input__label" [attr.for]="inputId()">{{ label() }}</label>
  <div class="bo-auth-phone-input__row">
    <select
      class="bo-auth-phone-input__code"
      [id]="inputId()"
      [formControl]="codeControl()"
      [attr.aria-label]="phoneAriaLabel() || 'Country code'"
    >
      @for (code of codeOptions(); track code) {
        <option [value]="code">{{ code }}</option>
      }
    </select>
    <input
      class="bo-auth-phone-input__phone"
      type="tel"
      [placeholder]="phonePlaceholder()"
      [attr.aria-label]="phoneAriaLabel() || label()"
      [formControl]="phoneControl()"
    />
  </div>
  @if (phoneControl().invalid && phoneControl().touched) {
    <p class="bo-auth-phone-input__error" role="alert">
      @if (phoneControl().errors?.['required']) {
        Este campo es obligatorio
      } @else if (phoneControl().errors?.['minlength']) {
        Minimo {{ phoneControl().errors?.['minlength'].requiredLength }} digitos
      } @else if (phoneControl().errors?.['e164']) {
        {{ phoneControl().errors?.['e164'] }}
      } @else if (phoneControl().errors?.['server']) {
        {{ phoneControl().errors?.['server'] }}
      } @else {
        Telefono invalido
      }
    </p>
  }
</div>
